<script setup lang="ts">
import { GameCard } from '@/components/game/game-card/index.js';
import { ref, watch } from 'vue';

interface Props {
    value?: number | string | null;
    active?: boolean;
    flipped?: boolean;
}

const props = defineProps<Props>();
const rotation = ref(getRotation(320, 40));

watch(
    () => props.active,
    (newValue) => {
        if (!newValue) return;
        rotation.value = getRotation(320, 40);
    },
);

function getRotation(minDeg: number, maxDeg: number) {
    if (minDeg < maxDeg) {
        return Math.floor(minDeg + Math.random() * (maxDeg - minDeg));
    } else {
        // Wrap-around case (e.g., 340° to 20°)
        const range1 = 360 - minDeg;
        const total = range1 + maxDeg;

        const rand = Math.random() * total;
        return Math.floor(rand < range1 ? minDeg + rand : rand - range1);
    }
}
</script>

<template>
    <div
        :style="`--card-rotation: ${rotation}deg; --spin-until: ${rotation + 360 * 2}deg;`"
        class="rotate-(--card-rotation) transition duration-1000 ease-out rounded-lg data-[active=true]:scale-60 data-[active=true]:rotate-(--spin-until)"
        :data-active="active"
    >
        <GameCard :face="flipped ? 'up' : 'down'" :selected="false" :value="value" disabled />
    </div>
</template>
